import React from "react";
import { LuBot, LuCpu, LuFileText, LuPencil, LuPower, LuTrash2 } from "react-icons/lu";
import { relativeDate } from "./BotsContent/Others/BotCard";
import { avatarColor, CardMenu, initials } from "./BotsContent/Others/BotListKit";

const knowledgeLabel = (assistant) => {
    const files = assistant?.files?.length || 0;
    if (files) return `${files} archivo${files === 1 ? "" : "s"}`;
    if (assistant?.instructions === "2" && assistant?.url) return "Hoja de Google";
    return "Instrucciones escritas";
};

const CRM_PILLS = [
    { key: "stage", label: "Embudo", color: "#2fae4e" },
    { key: "list", label: "Listas", color: "#14a3a3" },
    { key: "tags", label: "Etiquetas", color: "#0a7ba5" },
    { key: "fields", label: "Datos", color: "#f26b1d" },
    { key: "payment", label: "Pagos", color: "#e0a32e" },
    { key: "catalog", label: "Catálogo", color: "#7c5cd6" },
];

const AssistantCard = ({ assistant, onEdit, onDelete, onToggleActive }) => {
    const active = assistant?.active !== false;
    const usedIn = assistant?.usedIn || [];
    const description = (assistant?.role || assistant?.instructions_message || "").trim();
    const tools = [
        assistant?.transfer?.isTransfer && { label: "Transferir", color: "#FF2242" },
        assistant?.schedule?.isSchedule && { label: "Agenda", color: "#0a7ba5" },
        assistant?.sales?.activeSale && { label: "Ventas", color: "#2fae4e" },
        ...CRM_PILLS.filter((pill) => assistant?.crmTools?.[pill.key]?.enabled),
    ].filter(Boolean);
    const edit = () => onEdit(assistant.id);

    return (
        <article
            className={`su-card${active ? " live" : ""}`}
            tabIndex={0}
            aria-label={`Editar ${assistant?.name || "asistente"}`}
            onClick={edit}
            onKeyDown={(event) => {
                if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) {
                    event.preventDefault();
                    edit();
                }
            }}
        >
            <div className="su-card-h">
                <span className="su-av" style={{ "--c": avatarColor(assistant?.name) }} aria-hidden="true">
                    {initials(assistant?.name)}
                </span>
                <span style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
                    <span className="su-card-name" title={assistant?.name}>
                        {assistant?.name}
                    </span>
                    <span className="su-card-date" style={{ marginLeft: 0 }}>
                        Editado {relativeDate(assistant?.updated || assistant?.created)}
                    </span>
                </span>
                <CardMenu
                    items={[
                        { label: "Editar", icon: LuPencil, onClick: edit },
                        { label: active ? "Desactivar" : "Activar", icon: LuPower, onClick: () => onToggleActive(assistant.id, !active) },
                        { label: "Eliminar asistente", icon: LuTrash2, danger: true, onClick: () => onDelete(assistant.id) },
                    ]}
                />
            </div>
            <p className={`su-card-d${description ? "" : " none"}`}>{description || "Sin rol definido"}</p>
            <div className="su-meta" style={{ minHeight: "22px" }}>
                {tools.length ? (
                    <>
                        {tools.slice(0, 2).map((tool) => (
                            <span key={tool.label} className="su-tag dot" style={{ "--c": tool.color }}>
                                {tool.label}
                            </span>
                        ))}
                        {tools.length > 2 && <span title={tools.slice(2).map((tool) => tool.label).join(", ")}>+{tools.length - 2}</span>}
                    </>
                ) : (
                    <span>Solo conversa</span>
                )}
            </div>
            <div className="su-meta">
                <span title={knowledgeLabel(assistant)} style={{ minWidth: 0 }}>
                    <LuFileText className="su-ic" size={14} />
                    {knowledgeLabel(assistant)}
                </span>
                <span title={usedIn.length ? usedIn.map((bot) => bot.name).join(", ") : "Ningún bot lo usa"}>
                    <LuBot className="su-ic" size={14} />
                    {usedIn.length ? `En ${usedIn.length} bot${usedIn.length === 1 ? "" : "s"}` : "Sin bots"}
                </span>
            </div>
            <div className="su-card-f">
                <button
                    type="button"
                    role="switch"
                    aria-checked={active}
                    aria-label={`${active ? "Desactivar" : "Activar"} ${assistant?.name || "asistente"}`}
                    className={`su-sw${active ? " on" : ""}`}
                    onClick={(event) => {
                        event.stopPropagation();
                        onToggleActive(assistant.id, !active);
                    }}
                    onKeyDown={(event) => event.stopPropagation()}
                >
                    <span />
                </button>
                <span className={`su-state${active ? " on" : ""}`}>{active ? "Activo" : "Inactivo"}</span>
                <span className="su-card-date" style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                    <LuCpu className="su-ic" size={13} />
                    {assistant?.model || "gpt-4o-mini"}
                </span>
            </div>
        </article>
    );
};

export default AssistantCard;
